export default "__VITE_ASSET__c4b16857__"